import {Injectable} from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse
} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {CurrentUserService} from '../auth/current-user.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(
        private router: Router,
        private toastr: ToastrService,
        private currentUserService: CurrentUserService
    ) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const token = localStorage.getItem('currentUser');
        // Emailed report links are public: never send the back-office JWT to them.
        const isPublicReportLink = request.url.includes('/reporting/links/');
        if (token && !isPublicReportLink) {
            request = request.clone({
                setHeaders: { Authorization: `Bearer ${token}` }
            });
        }

        const isLoginRequest = request.url.includes('/auth/login');

        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401 && !isLoginRequest) {
                    localStorage.removeItem('currentUser');
                    this.currentUserService.clear();
                    this.toastr.warning('Votre session a expiré. Veuillez vous reconnecter.', 'Session expirée');
                    this.router.navigate(['/pages/login']);
                }
                return throwError(error);
            })
        );
    }
}
